import { actionTypes, MensajesActions, MensajeState, MensajesStatus, initialState } from './types'

const MensajesReducer = (state: MensajeState = initialState, action?: MensajesActions): MensajeState => {
  switch (action?.type) {
    case actionTypes.MENSAJES_FETCH: {
      const newFilters = { ...state.filters, ...action?.payload?.filters }
      const newStatus = action?.payload?.isInitial ? MensajesStatus.Loading : MensajesStatus.Filtering
      return { ...state, status: newStatus, filters: newFilters }
    }

    case actionTypes.MENSAJES_SUCCESS:
      return {
        ...state,
        status: MensajesStatus.Success,
        content: action?.payload?.content,
        number: action?.payload?.number,
        size: action?.payload?.size,
        total: action?.payload?.total,
      }

    case actionTypes.MENSAJES_ERROR:
      return {
        ...state,
        status: MensajesStatus.Error,
      }

    case actionTypes.MENSAJES_RESET:
      return {
        ...state,
        status: MensajesStatus.Idle,
        content: [],
        number: 0,
        size: 0,
        total: 0,
      }

    default:
      return state
  }
}

export default MensajesReducer
